import { PROGRESS_OVERLAY_ID_PREFIX } from "Common/componentUtils/constants";
import { themeVariables } from "Components/theme";
import classNames from "classnames";
import escape from "lodash/escape";
import isUndefined from "lodash/isUndefined";
import React, { memo, useEffect, useMemo } from "react";
import { useResizeDetector } from "react-resize-detector";
import { v4 as uuid } from "uuid";
import CancelPanel from "./cancelPanel";
import DotsIndicator from "./dotsIndicator";
import Styled from "./progressOverlay.styled";
import ProgressOverlayContext from "./progressOverlayContext";
function ProgressOverlayInner(props) {
    var _a;
    const id = useMemo(() => `${PROGRESS_OVERLAY_ID_PREFIX}${uuid()}`, []);
    const messageBoxId = useMemo(() => `messageBox_${id}`, [id]);
    const { width, ref: observableRef } = useResizeDetector();
    const overlayStyle = useMemo(() => {
        var _a, _b;
        const result = {
            ...(props.overlayStyle || {}),
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: props.zIndex
        };
        if (!((_a = props.overlayStyle) === null || _a === void 0 ? void 0 : _a.backgroundColor)) {
            result.backgroundColor = "#ffffff";
        }
        if (isUndefined((_b = props.overlayStyle) === null || _b === void 0 ? void 0 : _b.opacity)) {
            result.opacity = 0.5;
        }
        return result;
    }, [props.overlayStyle, props.zIndex]);
    const zIndexIndicator = props.zIndex ? props.zIndex + 1 : undefined;
    useEffect(() => {
        if (props.progressRef) {
            props.progressRef.current = {
                setMessage: (message, callback) => {
                    const messageBox = document.querySelector(`#${messageBoxId}`);
                    if (messageBox) {
                        messageBox.innerHTML = "";
                        messageBox.append(escape(message));
                    }
                    callback && callback();
                }
            };
        }
    }, []);
    const show = props.show && (props.ignoreParentOverlayInProgress || !((_a = props.context) === null || _a === void 0 ? void 0 : _a.overlayInProgressId));
    const context = useMemo(() => {
        if (show)
            return { overlayInProgressId: id };
        if (props.ignoreParentOverlayInProgress)
            return {};
        return props.context || {};
    }, [props.context, show, props.ignoreParentOverlayInProgress]);
    return (React.createElement(ProgressOverlayContext.Provider, { value: context },
        React.createElement(Styled.Container, { ref: observableRef, showCancelPanel: Boolean(props.onCancel && show), className: classNames("position-relative stretched-to-fit w-100-max", props.className), id: id, onContextMenu: props.onContextMenu, onClick: props.onClick },
            props.children,
            show && (React.createElement(React.Fragment, null,
                React.createElement("div", { style: overlayStyle }),
                props.onCancel ? (React.createElement(CancelPanel, { zIndex: zIndexIndicator, onCancel: props.onCancel, cancelText: props.cancelText, messageBoxId: messageBoxId })) : (props.useDots && (React.createElement(DotsIndicator, { zIndex: zIndexIndicator, fullWidth: width, messageBoxId: messageBoxId }))))))));
}
function ProgressOverlay(props) {
    return (React.createElement(ProgressOverlayContext.Consumer, null, (context) => (React.createElement(ProgressOverlayInner, { ...props, context: context }))));
}
export default memo(ProgressOverlay);
ProgressOverlay.defaultProps = {
    useDots: true,
    zIndex: parseInt(themeVariables["zindex-tooltip"]) + 1
};
